module.exports = __webpack_public_path__ + "static/media/isophya_camptoxypha_BD_020_APA.3ba06ad0.mp3";